import { render, staticRenderFns } from "./SpaceConfigurations.vue?vue&type=template&id=0a2eb932&scoped=true"
import script from "./SpaceConfigurations.vue?vue&type=script&lang=js"
export * from "./SpaceConfigurations.vue?vue&type=script&lang=js"
import style0 from "./SpaceConfigurations.vue?vue&type=style&index=0&id=0a2eb932&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2eb932",
  null
  
)

export default component.exports